module.exports = __webpack_public_path__ + "static/media/folders.369c3e53.svg";